import { createTheme } from "@mui/material/styles";
const logo = process.env.PUBLIC_URL + "/logo-white.svg";

const theme = createTheme({
  colors: {
    primary: {
      main: "#1976d2",
    },
  },
  custom: {
    logo: logo,
  },
});

export default theme;
